// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ship-status[data-v-09b1d446]{display:flex;flex-direction:column;padding-top:7px;padding-right:10px}.ship-status__row[data-v-09b1d446]{display:flex;align-items:center;height:21px}.ship-status__status[data-v-09b1d446]{max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ship-status__status-mark[data-v-09b1d446]{flex-shrink:0;width:7px;height:7px;border-radius:50%}.ship-status__status-mark-wrap[data-v-09b1d446]{display:flex;height:21px;flex-shrink:0}", ""]);
// Exports
module.exports = exports;
